// extracted by mini-css-extract-plugin
export default {"nav":"TopNavigation_nav__7sCDp","button":"TopNavigation_button__TAEOD","balance":"TopNavigation_balance__puo1r"};